import styles from "./spacer.module.css";

export const Spacer = () => {
  return <div className={styles["spacer-root"]} />;
};
